import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeFacade } from '@core/theme/facades/theme.facade';
import { ThemePreference } from '@kaseya-shared';
import { MenuKeyboardNavigationDirective, SpinnerComponent } from '@kaseya-design-components';
import { ThemeOption } from '@layout/profile-menu/models/theme-option.interface';

@Component({
  selector: 'itc-theme-options-list',
  templateUrl: 'theme-options-list.component.html',
  styleUrl: 'theme-options-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, SpinnerComponent, MenuKeyboardNavigationDirective],
})
export class ThemeOptionsListComponent {
  private readonly themeFacade = inject(ThemeFacade);

  readonly loading = this.themeFacade.loading;
  readonly activeTheme = this.themeFacade.themePreference;

  readonly themeOptions: ThemeOption[] = [
    { labelTranslateKey: 'theme.options.system', preference: ThemePreference.System },
    { labelTranslateKey: 'theme.options.light', preference: ThemePreference.Light },
    { labelTranslateKey: 'theme.options.dark', preference: ThemePreference.Dark },
  ];

  selectTheme(theme: ThemePreference): void {
    this.themeFacade.updateTheme({ theme });
  }
}
